export default __webpack_public_path__ + "static/media/quaver.6d36979a.png";